export default __webpack_public_path__ + "8e3a3d52ba9ab46a119544814dbf293f.png";